var minVal = 1,
    maxVal = 36;

$(function() {
  $(".range_L,.range_W,.range_H").ionRangeSlider({
      type: "double",
      grid: true,
      min: minVal,
      max: maxVal,
      from: minVal,
      to: maxVal,
      postfix: "&quot;",
      hide_min_max: true,
/*      onFinish: function (data) {
        calc();
      },*/
  });

  $('.btn-search-again').click(function(){scrollToEl('.size_finder')});

  $('.btn_calc').click(calc)

  $('.btn_clear_filters').click(clearFilters)


  function calc(){
    var minL=$('.range_L').data('from'),
        minW=$('.range_W').data('from'),
        minH=$('.range_H').data('from'),
        maxL=$('.range_L').data('to'),
        maxW=$('.range_W').data('to'),
        maxH=$('.range_H').data('to');

    minL = (minL ? minL : minVal);
    minW = (minW ? minW : minVal);
    minH = (minH ? minH : minVal);
    maxL = (maxL ? maxL : maxVal);
    maxW = (maxW ? maxW : maxVal);
    maxH = (maxH ? maxH : maxVal);

		$('.search-results-header').fadeIn();
    var matches='',comma='';
    for (d in data)
    {
      	var p = data[d];
        if ((parseFloat(p.l) >= minL && parseFloat(p.l) <= maxL) &&
          	(parseFloat(p.w)  >= minW && parseFloat(p.w) <= maxW) &&
          	(parseFloat(p.h) >= minH && parseFloat(p.h) <= maxH) )
        {
          matches += comma+'.p'+p.vid;
          comma=',';
        }
    }
    $('.search-products').hide();
    $('.search-product').hide().removeClass('alpha omega');
    if (!matches)
    	$('.no-results').fadeIn();
    else
    {
      $('.no-results').hide();
      $(matches).filter(function (index) {return ((index+1) % 3 == 1);}).addClass('alpha');
      $(matches).filter(function (index) {return ((index+2) % 3 == 1);}).addClass('omega');
      $(matches).show();
    }
    $('.search-products').fadeIn('slow',function(){scrollToEl('.search-results-header')});
  };

	function clearFilters() {
		console.log('clear size filters');
		$('.row--products').show();
    $('.search-products-default').hide();
		$('.products_list').html('');
		$('.applied-filters').hide();
    $('.btn_clear_filters').hide();
    //clear checked filters in sidebar
    $('.filter input:checkbox').each(function(i,filter) {
      $(filter).prop('checked',false);
    });
	}

  function scrollToEl(el){
    if ($('.header').is(':visible'))
      var offset= $(el).offset().top - $('.header').height() -50;
    else
      var offset= $(el).offset().top - $('.header').height() -50;

    $('html, body').animate({
      scrollTop: offset
    }, 500);
  }
	var sizeFilters = $('.sizeFilters');
	$('.toggleMobileFilter').click(function() {
		sizeFilters.slideToggle();
	});
})

/* Noticed FAQ Accordions */
$(document).ready(function() {

  if( window.innerWidth < 798 ) {
    $('.sidebar__filters').addClass('filter--closed');
  }

	$('.filter__type:not(#filter__toggle-group)').click(function(){
    console.log("not group");
		var $filter = $(this).closest('.filter');
		$(this).next('.filter__options').slideToggle(function(){
			$filter.toggleClass('filter--closed filter--open');
		});
	});
  $('.filter__toggle-group').click(function() {

    var $filter = $(this).closest('.filter');
    if (window.innerWidth < 780) {
      console.log("small");
      $(this).next('.filter__options').slideToggle(function(){
          $filter.toggleClass('filter--closed filter--open');
      })
    }
    else {
      $(this).next('.filter__options').slideDown(function(){
        $filter.removeClass('filter--closed').addClass('filter--open');
      })
    }
  });

	// Open filters on page load
	var filterId = window.location.hash;
	if($(filterId).length){
		$(filterId).find('.filter__type').click();
	}
});
